import { AllieIconProps } from '../../../components';

export const FileSearchIcon: React.FC<AllieIconProps> = ({ className, ...props }) => (
  <svg
    {...props}
    className={`stroke-icon ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
  >
    <path
      // eslint-disable-next-line max-len
      d="M23.8332 4.2832V11.1674C23.8332 12.1009 23.8332 12.5676 24.0148 12.9241C24.1746 13.2377 24.4296 13.4927 24.7432 13.6524C25.0997 13.8341 25.5664 13.8341 26.4998 13.8341H33.3841M27.1665 31.334L24.6665 28.834M23.8332 3.83398H15.1665C12.3662 3.83398 10.9661 3.83398 9.89655 4.37895C8.95574 4.85832 8.19084 5.62322 7.71147 6.56403C7.1665 7.63359 7.1665 9.03372 7.1665 11.834V29.1673C7.1665 31.9676 7.1665 33.3677 7.71147 34.4373C8.19084 35.3781 8.95574 36.143 9.89655 36.6224C10.9661 37.1673 12.3662 37.1673 15.1665 37.1673H25.8332C28.6334 37.1673 30.0336 37.1673 31.1031 36.6224C32.0439 36.143 32.8088 35.3781 33.2882 34.4373C33.8332 33.3677 33.8332 31.9676 33.8332 29.1673V13.834L23.8332 3.83398ZM26.3332 24.6673C26.3332 27.889 23.7215 30.5007 20.4998 30.5007C17.2782 30.5007 14.6665 27.889 14.6665 24.6673C14.6665 21.4457 17.2782 18.834 20.4998 18.834C23.7215 18.834 26.3332 21.4457 26.3332 24.6673Z"
      stroke="#344054"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
